<template>
  <div class="agent-view">
    <PageHero />
    <AgentChat mode="page" class="agent-chat-panel" />
  </div>
</template>

<script setup>
import PageHero from '@/components/common/PageHero.vue'
import AgentChat from '@/components/agent/AgentChat.vue'
</script>

<style lang="scss" scoped>
.agent-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 4px 28px 18px;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 4px 16px 12px;
  }
}

.agent-chat-panel {
  flex: 1 1 0;
  min-height: 0;
}
</style>
